<script setup>
import axios from 'axios'
import {inject, onMounted, ref} from 'vue'
import {useRoute, useRouter} from 'vue-router'

const eventsURL = 'api/events'
const backEndURL = process.env.VUE_APP_BACKEND_URL
const events = ref([])
const currentEvent = ref(null)

const route = useRoute()
const routeLocal = ref('')

onMounted(async () => {
    routeLocal.value = route.params.link
    events.value = await getEvents()
    await parseData()
})

const getEvents = async () => {
    try {
        const res = await axios.get(`${backEndURL}/${eventsURL}`)
        console.log('', res)
        return res.data
    } catch (err) {
        console.error(err)
    }
}

const parseData = async () => {
    const currentRoute = route.params.link
    currentEvent.value = events.value.find(item => item.link === currentRoute)
}
const contentData = inject('contentData')
const router = useRouter()

const navigateToHome = () => {
    router.push('/')
}
// if route/params.link === GuidedCityTour put logo assets/pht/tour.png
</script>

<template>
    <div class="relative">
        <!-- Logo -->
        <div class="absolute top-4 left-4">
            <a class="inline-block" href="#" @click.prevent="navigateToHome">
                <img :src="contentData.left_logo" alt="Logo" width="120" height="40" />
            </a>
        </div>

        <div>
            <!-- Page content -->
            <section class="py-16" id="registration">
                <div class="container px-4 mx-auto max-w-3xl" v-if="currentEvent">
                    <a href="https://www.zuerich.com/en" target="_blank">
                        <img
                            width="100"
                            height="100"
                            v-if="routeLocal === 'GuidedCityTour'"
                            class="block w-1/3 h-auto mx-auto mb-6 cursor-pointer"
                            src="/assets/pht/tour.png"
                            alt="" />
                    </a>
                    <div class="max-w-3xl mx-auto text-center">
                        <h1 class="font-heading text-3xl sm:text-4xl mt-2 mb-6">
                            {{ currentEvent.title }}
                        </h1>
                    </div>

                    <div
                        class="text-justify"
                        v-if="currentEvent.additional_info"
                        v-html="currentEvent.additional_info"></div>
                </div>
            </section>
        </div>
    </div>
</template>

<style scoped></style>
